import { CONNECTIVITY_STATUS } from '../../hooks/useConnectivityStatus';
import { useOfflineSync } from '../../context/OfflineSyncContext';

export default function OfflineSyncStatus() {
  const { status, counts, isSyncing, queueError, syncNow } = useOfflineSync();
  const hasReview = counts.review > 0 || Boolean(queueError);
  const offline = status === CONNECTIVITY_STATUS.OFFLINE;
  const limited = status === CONNECTIVITY_STATUS.LIMITED;
  const checking = status === CONNECTIVITY_STATUS.CHECKING;

  let label = 'Todo sincronizado';
  let detail = 'Conexión verificada con el servidor.';
  if (queueError) {
    label = 'No se pudo leer la cola offline';
    detail = queueError;
  } else if (hasReview) {
    label = `${counts.review} operación${counts.review === 1 ? '' : 'es'} requiere${counts.review === 1 ? '' : 'n'} revisión`;
    detail = 'La caja no podrá cerrarse hasta resolverla.';
  } else if (isSyncing || counts.syncing > 0) {
    label = 'Sincronizando operaciones';
    detail = `${counts.total} operación${counts.total === 1 ? '' : 'es'} en la cola local.`;
  } else if (offline || limited) {
    label = offline ? 'Sin conexión' : 'Conexión limitada';
    detail = counts.total > 0
      ? `${counts.total} operación${counts.total === 1 ? '' : 'es'} guardada${counts.total === 1 ? '' : 's'} en este PC.`
      : 'El servidor no está disponible. La aplicación conserva la información local.';
  } else if (checking) {
    label = 'Verificando conexión';
    detail = counts.total > 0 ? `${counts.total} operación${counts.total === 1 ? '' : 'es'} pendiente${counts.total === 1 ? '' : 's'}.` : 'Comprobando acceso al servidor.';
  } else if (counts.total > 0) {
    label = `${counts.total} operación${counts.total === 1 ? '' : 'es'} pendiente${counts.total === 1 ? '' : 's'}`;
    detail = 'Se enviarán automáticamente al servidor.';
  }

  const tone = hasReview
    ? 'border-rose-300 bg-rose-50 text-rose-950'
    : (offline || limited)
      ? 'border-amber-300 bg-amber-50 text-amber-950'
      : checking || isSyncing || counts.total > 0
        ? 'border-sky-300 bg-sky-50 text-sky-950'
        : 'border-emerald-200 bg-emerald-50 text-emerald-950';
  const dot = hasReview
    ? 'bg-rose-500'
    : (offline || limited)
      ? 'bg-amber-500'
      : checking || isSyncing || counts.total > 0
        ? 'bg-sky-500'
        : 'bg-emerald-500';

  return (
    <div role="status" aria-live="polite" className={`border-y px-4 py-2 ${tone}`}>
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2.5">
          <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${dot} ${isSyncing ? 'animate-pulse' : ''}`} />
          <div className="min-w-0 text-xs sm:flex sm:items-center sm:gap-2 sm:text-sm">
            <span className="font-black">{label}</span>
            <span className="block truncate opacity-80 sm:inline">{detail}</span>
          </div>
        </div>
        {status === CONNECTIVITY_STATUS.ONLINE && counts.total > 0 && (
          <button
            type="button"
            onClick={() => syncNow()}
            disabled={isSyncing}
            className="shrink-0 rounded-full bg-white px-3 py-1.5 text-xs font-bold shadow-sm ring-1 ring-black/5 disabled:cursor-wait disabled:opacity-60"
          >
            {isSyncing ? 'Sincronizando…' : 'Reintentar'}
          </button>
        )}
      </div>
    </div>
  );
}
